
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/crew",
      function () {
        return require("private-next-pages/dashboard/crew.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/crew"])
      });
    }
  